import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import { connect, useDispatch } from "react-redux";
import { withRouter, Link, useHistory} from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Form,
  Button,
  CardTitle,
  Input,
  FormFeedback,
  Alert,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Loader from "../../components/Common/Loader"

import { campaignCreate } from "../../store/actions";
import { getAccountFullList } from "../../helpers/backend";
import { getContactsFullList } from "../../helpers/backend";

const CampaignCreate = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();


  const [accountList, setAccountList] = useState({});
  const getAccountData = async () => {
    const response = await getAccountFullList();
    const data = response.data;
    setAccountList(data);
  };

  const [contactsList, setContactsList] = useState({});
  const getContactsData = async () => {
    const response = await getContactsFullList();
    const data = response.data;
    setContactsList(data);
  };

  useEffect(() => {
    getAccountData();
    getContactsData();

  }, []);

  const [formData, setFormData] = useState({
    
    name: "",
    account: "",
    description:"",
    encargado: "",
  });
  
  const {
    name,    
    description,    
  } = formData;
  
  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  console.log(formData);

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(campaignCreate(formData));
  };
  
  const redirect = () => {
    history.push("/campaign");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>  | Campañas </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="" breadcrumbItem=" Campañas" />
          {props.loading ? (
            <Loader />
          ) : (
          <div className="d-flex justify-content-center">
              {props.campaignCreated.id ? (
                <SweetAlert
                  title="¡Hecho!"
                  success
                  showConfirm={true}
                  onConfirm={() => {
                    redirect();
                  }}
                >
                  Se ha
                  agregado <b>{props.campaignCreated.nombre}</b> correctamente.
                </SweetAlert>
              ) : null}

              <Card
                style={{
                  width: "60rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="font-size-20">Campaign</h2>
                </CardTitle>
                <CardBody>
                <Form onSubmit={onSubmit} className="form-control">
                  <Row className="justify-content-md-center" >
                    <Col lg={10}>
                <Row className="mt-3">
                  <Col>
                    <Label
                      for="name"                      
                    >
                      Nombre
                    </Label>
                    <Input                      
                      id="name"
                      name="name"
                      type="name"
                      onChange={onChange}
                      value= {name}
                      autoFocus
                      required
      
                    />
                    {props.error && props.error.name ? (
                      <Alert color = 'danger' className="mt-2">{props.error.name}</Alert>
                    ):null}
                  </Col>  
                  <Col>
                    <Label
                      for="account"
                      
                    >
                      Cuenta
                    </Label>
                    <Select                     
                      id="account"
                      name="account"  
                      options={Array.isArray(accountList)? accountList.map(item=> 
                        ({label: item.get_full_name, value: item.id})):[]}  
                      placeholder='Seleccione'                 
                      onChange={ (item) => setFormData({
                        ...formData,
                        account: item.value,
                      })

                      }
                                          
                      required 
                    />                   
                    
                    {props.error && props.error.account ? (
                    <Alert color = 'danger' className="mt-2">{props.error.account}</Alert>
                    ):null}
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col>  
                    <Label
                      for="description"
                      
                    >
                      Descripcion
                    </Label>
                    <Input
                     
                      id="description"
                      name="description"
                      type="text"
                      onChange={onChange}
                      value={description}

                      required 
                    />
                   
                    <FormFeedback>{props.error.description}</FormFeedback>
                    

                  </Col>
                  <Col>
                    <Label
                      for="encargado"                      
                    >  Encargado
                    </Label>  
                   <Select   
                      isMulti={true}                  
                      id="encargado"
                      name="encargado"  
                      options={ Array.isArray(contactsList) ? 
                        contactsList.map(item=> ({label: item.get_full_name, value: item.id})) : [] } 
                      placeholder='Seleccione'                  
                      onChange={(item) => setFormData({
                        ...formData,
                        encargado : item && item.map( item => item.value)
                      })}                                          
                      required 
                    /> 
                    

                    {props.error && props.error.encargado ? (
                    <Alert color = 'danger' className="mt-2">{props.error.encargado}</Alert>
                    ):null}

                  </Col>
                </Row>

                    <Row className="justify-content-md-center mt-5 ms-4">
                      <Col lg={4}>
                        <Link className="btn btn-secondary me-4" to="/campaign">
                          Cancelar
                        </Link>

                        <Button color="success" type="submit">
                          Crear
                        </Button>
                      </Col>
                    </Row>
                    </Col>
                  </Row>
                </Form>
                </CardBody>
              </Card>

            
          </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  const { error, loading, campaignCreated } = state.Campaign;
  return { error, loading, campaignCreated };
};

export default withRouter(connect(mapStateToProps)(CampaignCreate));